export default __webpack_public_path__ + "static/media/5.b1895c1d.png";